import { PartnerRouteRestriction } from "routes/helpers";
import type { GeneratePageParams } from "routes/interfaces";

export default [
	{
		pageDirPath: '/OrderImport/List',
		title: 'Importação de pedido',
		pathname: '/importacao-pedido',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/UploadExceptions',
		title: 'Resultado da importação',
		pathname: '/importacao-pedido/resultado/:importId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED']).orderImport,
	},

	{
		pageDirPath: '/pos/Distributors',
		title: 'Alteração de distribuidores',
		pathname: '/importacao-pedido/alteracao-de-distribuidores',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/Customization',
		title: 'Customização de pedido',
		pathname: '/importacao-pedido/customizacao-de-pedido/:importId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},


	{
		pageDirPath: '/OrderImport/Promotion/List',
		title: 'Promoções',
		pathname: '/importacao-pedido/customizacao-de-pedido/:importId/promocoes/:productId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/Promotion/Details',
		title: 'Detalhes da promoção',
		pathname: '/importacao-pedido/customizacao-de-pedido/detalhes-da-promocao',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/OrderRevision',
		title: 'Finalizar pedido',
		pathname: '/importacao-pedido/finalizar-pedido/:importId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/Success',
		title: 'Confirmação de compra',
		pathname: '/importacao-pedido/confirmacao-de-compra',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},

	{
		pageDirPath: '/OrderImport/MissingDistributor',
		title: 'Ajustes necessários',
		pathname: '/importacao-pedido/ajustes-necessarios/:orderImportId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED']).orderImport,
	},

	{
		pageDirPath: '/pos/Distributors',
		title: 'Seleção de distribuidores',
		pathname: '/importacao-pedido/ajustes-necessarios/selecao-de-distribuidores/:orderImportId',
		headerType: 'logged',

		type: 'PRIVATE',
		needContext: null,
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED']).orderImport,
	},

	{
		pathname: '/importacao-pedido/otimizacao',
		pageDirPath: '/checkout/OrderOptimization',
		title: 'Otimização de pedido',

		type: 'PRIVATE',
		needContext: null,
		headerType: 'logged',
		allowedRestrictions: PartnerRouteRestriction(['SIMULATED', 'QUOTATION']).orderImport,
	},
] satisfies GeneratePageParams[];